
import { Vue, Component } from 'vue-property-decorator'
import ConstructionWorker from '@/types/constructionWorker'
import ConstructionWorkerShowDetailsTab from '@/views/constructionWorker/tabs/show/ConstructionWorkerShowDetailsTab.vue'
import ls from '@/ls'

@Component({
  components: { ConstructionWorkerShowDetailsTab }
})

export default class ConstructionWorkerShow extends Vue {
  settings = {
    routeNames: { list: 'constructionWorkers', show: 'constructionWorkerShow', edit: 'constructionWorkerEdit' },
    routeParamKey: 'constructionWorkerId',
    functionNames: { setCurrent: 'setCurrentConstructionWorker', clearCurrent: 'clearCurrentConstructionWorker', save: 'saveConstructionWorker' },
    getterNames: { current: 'currentConstructionWorker', loading: 'loadingConstructionWorker' }
  }

  currentTab:string = ls.get('constructionWorkerShowActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('constructionWorkerShowActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, id:number|undefined, paramKey:string|undefined) : void {
    if (id && typeof paramKey === 'string') {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : ConstructionWorker {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }
}
